import {Module} from "vuex";

import {RootStateType} from "@/store";

import actions from "./actions";
import mutations from "./mutations";
import {TradeContractFormatGroupState} from "./model";

let state: TradeContractFormatGroupState = {
  groups: [],
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
} as Module<TradeContractFormatGroupState, RootStateType>;
